import { useContext } from "react";
import { NavTablesContext } from "./navTables.provider";
import NavTablesStore from "./navTablesStore";

/**
 * Hook to access the NavTables store from context
 * Throws an error if used outside of NavTablesProvider
 */
const useNavTablesStore = (): NavTablesStore => {
  const store = useContext(NavTablesContext);
  
  if (!store) {
    throw new Error("useNavTablesStore must be used within a NavTablesProvider");
  }
  
  return store;
};

export default useNavTablesStore;